module.exports = __webpack_public_path__ + "img/633.8497b264.jpg";